import { Accordion, AccordionItem, AccordionHeader, AccordionBody } from 'react-bootstrap';
import { FaPhoneAlt, FaClock, FaEnvelope, FaHeadset } from 'react-icons/fa';

export default function ContactUs() {
  return (
    <div
      className="p-4 text-white"
      style={{
        backgroundImage: `url('/Jazuz-moving-truck.png')`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        minHeight: '100vh',
        backgroundAttachment: 'fixed',
      }}
    >
      <div className="bg-dark bg-opacity-75 p-4 rounded">
        <h2 className="mb-4 text-white">Contact Us</h2>

        <div className="mb-4">
          <p><FaPhoneAlt className="me-2 text-primary" /> <strong>Phone:</strong> +1 306-713-9244 (Canada) | +234 812-367-4528 (Nigeria)</p>
          <p><FaEnvelope className="me-2 text-primary" /> <strong>Email:</strong> info@jazuzmovingcompany.com</p>
        </div>

        <Accordion defaultActiveKey="0">
          <AccordionItem eventKey="0">
            <AccordionHeader><FaClock className="me-2 text-primary" /> Sales Office Hours</AccordionHeader>
            <AccordionBody>
              <ul className="list-unstyled">
                <li><strong>Monday – Friday:</strong> 7am - 9pm</li>
                <li><strong>Saturday:</strong> 9am - 9pm</li>
                <li><strong>Sunday:</strong> 10am - 7pm</li>
              </ul>
            </AccordionBody>
          </AccordionItem>

          <AccordionItem eventKey="1">
            <AccordionHeader><FaHeadset className="me-2 text-success" /> Customer Support</AccordionHeader>
            <AccordionBody>
              <p>Our dedicated support team is available <strong>7 days a week</strong>:</p>
              <ul className="list-unstyled">
                <li><strong>Monday – Saturday:</strong> 7am - 9pm</li>
                <li><strong>Sunday:</strong> 10am - 7pm</li>
              </ul>
            </AccordionBody>
          </AccordionItem>
        </Accordion>
      </div>
    </div>
  );
}
